/**
 * Maestria por tanque — progressão de vínculo com cada máquina.
 *
 * Cada abate feito com um tanque conta para a maestria DAQUELE tanque
 * (persistida em useProgress.tankKills). Recompensa é prestígio visual:
 * estrelas e título no hangar/loja — nunca stats (anti-P2W).
 */

/** Abates necessários para alcançar cada nível (índice 0 = nível 1). */
export const MASTERY_THRESHOLDS = [10, 30, 75, 150, 300] as const;

export const MASTERY_MAX_LEVEL = MASTERY_THRESHOLDS.length;

export interface TankMastery {
  kills: number;
  /** 0 (sem maestria) até MASTERY_MAX_LEVEL. */
  level: number;
  /** Abates para o próximo nível; null quando está no máximo. */
  nextThreshold: number | null;
  /** Progresso 0..1 dentro do nível atual. */
  progress: number;
}

export function computeTankMastery(kills: number): TankMastery {
  let level = 0;
  for (const threshold of MASTERY_THRESHOLDS) {
    if (kills >= threshold) level++;
    else break;
  }

  if (level >= MASTERY_MAX_LEVEL) {
    return { kills, level, nextThreshold: null, progress: 1 };
  }

  const prev = level === 0 ? 0 : MASTERY_THRESHOLDS[level - 1];
  const next = MASTERY_THRESHOLDS[level];
  return {
    kills,
    level,
    nextThreshold: next,
    progress: Math.min(1, (kills - prev) / (next - prev)),
  };
}
